import API from '@shared/config/services/url.config';
import React, { useEffect, useState } from 'react';
import Img from '../../Img';

// Convierte una URL de archivo privado (/transactional/s3/private?filename=...) en la URL del
// proxy del backend (/api/backend/archivos/ver?filename=...), que descarga con la api-key
// server-side. Así el front nunca necesita la api-key.
const toProxyUrl = (src) => {
	try {
		const u = new URL(src, window.location.origin);
		const filename = u.searchParams.get('filename');
		if (filename) return `${API.E2E || '/api/backend'}/archivos/ver?filename=${encodeURIComponent(filename)}`;
	} catch { /* src no es una URL con filename, usar tal cual */ }
	return src;
};

const imageCache = new Map();
const MAX_CACHE_SIZE = 50;

function addToCache(src, objectURL) {
	if (imageCache.size >= MAX_CACHE_SIZE) {
		const firstKey = imageCache.keys().next().value;
		URL.revokeObjectURL(imageCache.get(firstKey));
		imageCache.delete(firstKey);
	}
	imageCache.set(src, objectURL);
}

const PrivateImg = ({ src, imgDefault, enableCache = false, ...props }) => {
	const [imageUrl, setImageUrl] = useState('');

	useEffect(() => {
		let isCancelled = false;
		let objectURL = null;

		const loadImage = async () => {
			if (!src) {
				setImageUrl(imgDefault);
				return;
			}

			// Data URLs (base64) y blob URLs ya son locales, no necesitan fetch con auth
			if (src.startsWith('data:') || src.startsWith('blob:')) {
				setImageUrl(src);
				return;
			}

			if (enableCache && imageCache.has(src)) {
				setImageUrl(imageCache.get(src));
				return;
			}

			try {
				setImageUrl('');

				const response = await fetch(toProxyUrl(src), {
					credentials: 'include',
				});
				if (!response.ok) throw new Error('Error al obtener imagen');

				const blob = await response.blob();
				objectURL = URL.createObjectURL(blob);

				if (enableCache) {
					addToCache(src, objectURL);
				}

				if (!isCancelled) {
					setImageUrl(objectURL);
				}
			} catch (err) {
				if (!isCancelled) setImageUrl(imgDefault);
			}
		};

		loadImage();

		return () => {
			isCancelled = true;
			if (!enableCache && objectURL) {
				URL.revokeObjectURL(objectURL);
			}
		};
	}, [src, imgDefault, enableCache]);

	return <Img src={imageUrl} imgDefault={imgDefault} {...props} />;
};

export default React.memo(PrivateImg);
